<template>
  <v-dialog
    v-model="dialogCargaLaboral.estatus"
    max-width="1300px"
    transition="dialog-transition"
    scrollable
  >
    <v-card>
      <v-card-title class="text-subtitle-1">
        Carga laboral de teachers
        <v-spacer></v-spacer>
        <span class="text-caption grey--text mr-2" v-if="cicloLabel">
          {{ cicloLabel }} · Semana {{ semana }}
        </span>
        <v-btn
          color="green"
          small
          tile
          dark
          :disabled="!filasVisibles.length"
          @click="exportar"
        >
          <v-icon small left>mdi-microsoft-excel</v-icon>
          Excel
        </v-btn>
      </v-card-title>

      <v-card-text>
        <p class="text-caption grey--text mb-3">
          Horas de la semana seleccionada, con las mismas reglas del rol:
          teens entre semana = 2 días × 1.5 h; teens sabatino/dominical = 3 h (no cuentan jueves/viernes);
          adultos L-V = 1 h por día que sí imparte; sabatino/dominical adulto = 1 h por bloque.
        </p>

        <v-row dense class="mb-2">
          <v-col cols="12" sm="6" md="2">
            <v-autocomplete
              filled
              dense
              hide-details
              single-line
              :items="opcionesSemana"
              v-model="semana"
              item-text="text"
              item-value="value"
              label="Semana"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-autocomplete
              filled
              dense
              hide-details
              single-line
              clearable
              :items="opcionesEscuela"
              v-model="filtroEscuela"
              item-text="text"
              item-value="value"
              label="Escuela"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              filled
              dense
              hide-details
              single-line
              clearable
              :items="opcionesPlantel"
              v-model="filtroPlantel"
              label="Plantel"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              filled
              dense
              hide-details
              single-line
              clearable
              :items="opcionesTeacher"
              v-model="filtroTeacher"
              label="Teacher"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="search"
              label="Buscar"
              dense
              filled
              hide-details
              single-line
              clearable
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense class="mb-3">
          <v-col cols="12">
            <v-btn
              small
              tile
              class="mr-2"
              :dark="vista === 'unicos'"
              :outlined="vista !== 'unicos'"
              color="teal darken-1"
              @click="vista = 'unicos'"
            >
              Maestros únicos
            </v-btn>
            <v-btn
              small
              tile
              :dark="vista === 'detalle'"
              :outlined="vista !== 'detalle'"
              color="teal darken-1"
              @click="vista = 'detalle'"
            >
              Detalle
            </v-btn>
            <span class="text-caption grey--text ml-3">
              {{ vista === 'unicos' ? 'Un renglón por teacher (suma planteles y escuelas).' : 'Un renglón por teacher, plantel y escuela.' }}
            </span>
          </v-col>
        </v-row>

        <v-row dense class="mb-3">
          <v-col cols="6" md="2">
            <div class="text-caption grey--text">Teachers</div>
            <div class="text-h6">{{ filasVisibles.length }}</div>
          </v-col>
          <v-col cols="6" md="2">
            <div class="text-caption grey--text">Grupos</div>
            <div class="text-h6">{{ totales.cantidad_grupos }}</div>
          </v-col>
          <v-col cols="6" md="2">
            <div class="text-caption grey--text">Horas totales</div>
            <div class="text-h6">{{ totales.horas_totales }}</div>
          </v-col>
          <v-col cols="6" md="2">
            <div class="text-caption grey--text">Entre semana</div>
            <div class="text-h6">{{ totales.horas_entre_semana }}</div>
          </v-col>
          <v-col cols="6" md="2">
            <div class="text-caption grey--text">Sabatinas</div>
            <div class="text-h6">{{ totales.horas_sabatinas }}</div>
          </v-col>
          <v-col cols="6" md="2">
            <div class="text-caption grey--text">Dominicales</div>
            <div class="text-h6">{{ totales.horas_dominicales }}</div>
          </v-col>
        </v-row>

        <v-data-table
          :key="vista"
          :headers="headersActivos"
          :items="filasVisibles"
          class="elevation-0"
          dense
          height="480"
          fixed-header
          item-key="key"
          sort-by="posicion"
          :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
        >
          <template v-slot:item.posicion="{ item }">
            <strong>#{{ item.posicion }}</strong>
          </template>

          <template v-slot:item.escuela="{ item }">
            <v-chip
              x-small
              label
              :color="chipEscuela(item.escuela)"
            >
              {{ item.escuela }}
            </v-chip>
          </template>

          <template v-slot:body.append>
            <tr v-if="filasVisibles.length" class="fila-totales">
              <td></td>
              <td><strong>TOTAL</strong></td>
              <td></td>
              <td></td>
              <td class="text-right"><strong>{{ totales.cantidad_grupos }}</strong></td>
              <td class="text-right"><strong>{{ totales.horas_totales }}</strong></td>
              <td class="text-right"><strong>{{ totales.horas_entre_semana }}</strong></td>
              <td class="text-right"><strong>{{ totales.horas_sabatinas }}</strong></td>
              <td class="text-right"><strong>{{ totales.horas_dominicales }}</strong></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="black"
          small
          tile
          dark
          @click="dialogCargaLaboral.estatus = false"
        >
          <v-icon small left>mdi-close</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import funcionesExcel from '@/mixins/funcionesExcel'

const DIAS = [
  { slot: 'lu', flag: 'lunes' },
  { slot: 'ma', flag: 'martes' },
  { slot: 'mi', flag: 'miercoles' },
  { slot: 'ju', flag: 'jueves' },
  { slot: 'vi', flag: 'viernes' },
]

const TEACHERS_IGNORAR = [0, 1202]

function redondear (n) {
  return Math.round((Number(n) || 0) * 100) / 100
}

function nombreEscuela (id) {
  return Number(id) === 2 ? 'FAST' : 'INBI'
}

function esTeens (grupo) {
  const nombre = (grupo && grupo.grupo) ? String(grupo.grupo).toUpperCase() : ''
  return nombre.indexOf('TEENS') !== -1
}

function teacherValido (idTeacher, nombre) {
  if (idTeacher == null || idTeacher === '') return false
  const n = Number(idTeacher)
  if (TEACHERS_IGNORAR.indexOf(n) !== -1) return false
  if (!nombre) return false
  const nom = String(nombre).toUpperCase()
  if (nom === 'SIN TEACHER') return false
  return true
}

function horasSabDom (grupo, idTeacher, semana, teens, horasDia) {
  const slots = teens ? ['lu', 'ma', 'mi'] : ['lu', 'ma', 'mi', 'ju', 'vi']
  if (teens) {
    let asignado = false
    for (let i = 0; i < slots.length; i++) {
      if (grupo[slots[i] + semana] == idTeacher) {
        asignado = true
        break
      }
    }
    return asignado ? (horasDia || 3) : 0
  }
  let horas = 0
  for (let i = 0; i < slots.length; i++) {
    if (grupo[slots[i] + semana] == idTeacher) {
      horas += 1
    }
  }
  return horas
}

function horasEntreSemana (grupo, idTeacher, semana, horasDia) {
  let horas = 0
  for (let i = 0; i < DIAS.length; i++) {
    const d = DIAS[i]
    if (grupo[d.flag] && grupo[d.slot + semana] == idTeacher) {
      horas += horasDia
    }
  }
  return horas
}

function ordenarYPosicionar (filas) {
  const copia = filas.slice()
  copia.sort(function (a, b) {
    if (b.cantidad_grupos !== a.cantidad_grupos) return b.cantidad_grupos - a.cantidad_grupos
    if (b.horas_totales !== a.horas_totales) return b.horas_totales - a.horas_totales
    if (a.teacher !== b.teacher) return a.teacher < b.teacher ? -1 : 1
    return 0
  })
  return copia.map(function (row, idx) {
    return Object.assign({}, row, { posicion: idx + 1 })
  })
}

function coincidenciaBusqueda (row, q) {
  const campos = [
    row.posicion,
    row.escuela,
    row.plantel,
    row.teacher,
    row.cantidad_grupos,
    row.horas_totales,
    row.horas_entre_semana,
    row.horas_sabatinas,
    row.horas_dominicales,
  ]
  for (let i = 0; i < campos.length; i++) {
    const val = campos[i] == null ? '' : String(campos[i])
    if (val.toLowerCase().indexOf(q) !== -1) return true
  }
  return false
}

export default {
  mixins: [funcionesExcel],

  props: {
    dialogCargaLaboral: { type: Object, required: true },
    gruposRoles: { type: Array, default: function () { return [] } },
    selectedHeaders: { type: [Number, String], default: 1 },
    cicloLabel: { type: String, default: '' },
  },

  data: function () {
    return {
      search: '',
      vista: 'unicos',
      semana: 1,
      filtroEscuela: null,
      filtroPlantel: null,
      filtroTeacher: null,
      opcionesSemana: [
        { text: 'Semana 1', value: 1 },
        { text: 'Semana 2', value: 2 },
        { text: 'Semana 3', value: 3 },
        { text: 'Semana 4', value: 4 },
      ],
      opcionesEscuela: [
        { text: 'INBI', value: 'INBI' },
        { text: 'FAST', value: 'FAST' },
      ],
    }
  },

  created: function () {
    this.semana = this.selectedHeaders || 1
  },

  watch: {
    filtroEscuela: function () {
      this.filtroPlantel = null
      this.filtroTeacher = null
    },
    filtroPlantel: function () {
      this.filtroTeacher = null
    },
  },

  computed: {
    filas: function () {
      const grupos = (this.gruposRoles || []).filter(function (el) {
        return el.deleted == 0
      })
      const semana = this.semana || 1
      const mapa = {}

      for (let g = 0; g < grupos.length; g++) {
        const grupo = grupos[g]
        const horasDia = Number(grupo.horas_dia) || 0
        const teens = esTeens(grupo)
        const escuela = nombreEscuela(grupo.id_unidad_negocio)
        const plantel = grupo.plantel ? grupo.plantel : 'SIN PLANTEL'
        const vistos = {}

        for (let d = 0; d < DIAS.length; d++) {
          const slot = DIAS[d].slot + semana
          const idTeacher = grupo[slot]
          const nombre = grupo[slot + '_n']
          if (!teacherValido(idTeacher, nombre)) continue
          const claveTeacher = String(idTeacher)
          if (vistos[claveTeacher]) continue
          vistos[claveTeacher] = true

          let sab = 0
          let dom = 0
          let lv = 0
          if (grupo.sabado) {
            sab = horasSabDom(grupo, idTeacher, semana, teens, horasDia)
          } else if (grupo.domingo) {
            dom = horasSabDom(grupo, idTeacher, semana, teens, horasDia)
          } else {
            lv = horasEntreSemana(grupo, idTeacher, semana, horasDia)
          }

          if (!sab && !dom && !lv) continue

          const key = escuela + '|' + plantel + '|' + idTeacher
          if (!mapa[key]) {
            mapa[key] = {
              key: key,
              escuela: escuela,
              plantel: plantel,
              id_teacher: idTeacher,
              teacher: nombre,
              cantidad_grupos: 0,
              horas_entre_semana: 0,
              horas_sabatinas: 0,
              horas_dominicales: 0,
              horas_totales: 0,
            }
          }
          mapa[key].cantidad_grupos += 1
          mapa[key].horas_entre_semana += lv
          mapa[key].horas_sabatinas += sab
          mapa[key].horas_dominicales += dom
        }
      }

      const lista = Object.keys(mapa).map(function (k) {
        const row = mapa[k]
        row.horas_entre_semana = redondear(row.horas_entre_semana)
        row.horas_sabatinas = redondear(row.horas_sabatinas)
        row.horas_dominicales = redondear(row.horas_dominicales)
        row.horas_totales = redondear(
          row.horas_entre_semana + row.horas_sabatinas + row.horas_dominicales
        )
        return row
      })

      return lista
    },

    opcionesPlantel: function () {
      const set = {}
      const filas = this.filasPorEscuela
      for (let i = 0; i < filas.length; i++) {
        set[filas[i].plantel] = true
      }
      return Object.keys(set).sort()
    },

    opcionesTeacher: function () {
      const set = {}
      const filas = this.filasPorEscuelaPlantel
      for (let i = 0; i < filas.length; i++) {
        set[filas[i].teacher] = true
      }
      return Object.keys(set).sort()
    },

    filasPorEscuela: function () {
      if (!this.filtroEscuela) return this.filas
      const escuela = this.filtroEscuela
      return this.filas.filter(function (el) {
        return el.escuela === escuela
      })
    },

    filasPorEscuelaPlantel: function () {
      let filas = this.filasPorEscuela
      if (this.filtroPlantel) {
        const plantel = this.filtroPlantel
        filas = filas.filter(function (el) {
          return el.plantel === plantel
        })
      }
      return filas
    },

    filasBase: function () {
      let filas = this.filasPorEscuelaPlantel
      if (this.filtroTeacher) {
        const teacher = this.filtroTeacher
        filas = filas.filter(function (el) {
          return el.teacher === teacher
        })
      }
      return filas
    },

    filasDetalle: function () {
      return ordenarYPosicionar(this.filasBase)
    },

    filasUnicos: function () {
      const base = this.filasBase
      const mapa = {}
      for (let i = 0; i < base.length; i++) {
        const row = base[i]
        const key = String(row.id_teacher)
        if (!mapa[key]) {
          mapa[key] = {
            key: 'unico|' + key,
            id_teacher: row.id_teacher,
            teacher: row.teacher,
            escuelas: {},
            planteles: {},
            cantidad_grupos: 0,
            horas_entre_semana: 0,
            horas_sabatinas: 0,
            horas_dominicales: 0,
          }
        }
        mapa[key].escuelas[row.escuela] = true
        mapa[key].planteles[row.plantel] = true
        mapa[key].cantidad_grupos += row.cantidad_grupos
        mapa[key].horas_entre_semana += row.horas_entre_semana
        mapa[key].horas_sabatinas += row.horas_sabatinas
        mapa[key].horas_dominicales += row.horas_dominicales
      }

      const lista = Object.keys(mapa).map(function (k) {
        const row = mapa[k]
        const escuelas = Object.keys(row.escuelas).sort()
        const planteles = Object.keys(row.planteles).sort()
        const lv = redondear(row.horas_entre_semana)
        const sab = redondear(row.horas_sabatinas)
        const dom = redondear(row.horas_dominicales)
        return {
          key: row.key,
          id_teacher: row.id_teacher,
          teacher: row.teacher,
          escuela: escuelas.join(' / '),
          plantel: planteles.join(', '),
          cantidad_grupos: row.cantidad_grupos,
          horas_entre_semana: lv,
          horas_sabatinas: sab,
          horas_dominicales: dom,
          horas_totales: redondear(lv + sab + dom),
        }
      })

      return ordenarYPosicionar(lista)
    },

    filasMostradas: function () {
      return this.vista === 'detalle' ? this.filasDetalle : this.filasUnicos
    },

    filasVisibles: function () {
      const q = (this.search || '').toString().toLowerCase().trim()
      if (!q) return this.filasMostradas
      return this.filasMostradas.filter(function (row) {
        return coincidenciaBusqueda(row, q)
      })
    },

    headersActivos: function () {
      return [
        { text: '#', value: 'posicion', width: '64px' },
        { text: 'Escuela', value: 'escuela' },
        { text: this.vista === 'unicos' ? 'Planteles' : 'Plantel', value: 'plantel' },
        { text: 'Teacher', value: 'teacher' },
        { text: 'Cantidad de grupos', value: 'cantidad_grupos', align: 'end' },
        { text: 'Horas totales', value: 'horas_totales', align: 'end' },
        { text: 'Entre semana', value: 'horas_entre_semana', align: 'end' },
        { text: 'Sabatinas', value: 'horas_sabatinas', align: 'end' },
        { text: 'Dominicales', value: 'horas_dominicales', align: 'end' },
      ]
    },

    totales: function () {
      const filas = this.filasVisibles
      let lv = 0
      let sab = 0
      let dom = 0
      let grupos = 0
      for (let i = 0; i < filas.length; i++) {
        lv += filas[i].horas_entre_semana
        sab += filas[i].horas_sabatinas
        dom += filas[i].horas_dominicales
        grupos += filas[i].cantidad_grupos
      }
      return {
        cantidad_grupos: grupos,
        horas_entre_semana: redondear(lv),
        horas_sabatinas: redondear(sab),
        horas_dominicales: redondear(dom),
        horas_totales: redondear(lv + sab + dom),
      }
    },
  },

  methods: {
    chipEscuela: function (escuela) {
      if (escuela === 'FAST') return 'pink lighten-4'
      if (escuela === 'INBI') return 'light-blue lighten-4'
      return 'grey lighten-3'
    },

    exportar: function () {
      const esUnicos = this.vista === 'unicos'
      const colPlantel = esUnicos ? 'Planteles' : 'Plantel'
      const rows = this.filasVisibles.map(function (item) {
        const fila = {}
        fila['#'] = item.posicion
        fila.Escuela = item.escuela
        fila[colPlantel] = item.plantel
        fila.Teacher = item.teacher
        fila['Cantidad de grupos'] = item.cantidad_grupos
        fila['Horas totales'] = item.horas_totales
        fila['Entre semana'] = item.horas_entre_semana
        fila.Sabatinas = item.horas_sabatinas
        fila.Dominicales = item.horas_dominicales
        return fila
      })
      if (!rows.length) return
      const modo = esUnicos ? 'unicos' : 'detalle'
      this.exportarExcelDirecto(rows, 'carga_laboral_' + modo)
    },
  },
}
</script>

<style scoped>
.fila-totales td {
  background: #f5f5f5;
  border-top: 1px solid #e0e0e0;
}
</style>
